import React from 'react';
import SwitchRow from './SwitchRow';
import { choice } from './choiceStyles';
import { formatNo } from '../../../utils/truckCatalog';
import { COLORS } from '../../../styles/tokens';

export const MAX_FULL_LOADS = 10;

// Fulle lass: bestiller velger antall hele lass i stedet for en mengde. Hvert lass blir en egen ordre.
export default function FullLoadsPicker({ value, onChange, payloadTons, max = MAX_FULL_LOADS }) {
  const total = payloadTons > 0 ? Math.round(value.count * payloadTons * 10) / 10 : null;
  const step = (d) => onChange({ on: true, count: Math.min(max, Math.max(1, value.count + d)) });
  return (
    <div style={{ ...choice.card, padding: '4px 14px 12px' }}>
      <SwitchRow
        title="Fulle lass" sub="Bestill ett eller flere hele lass i stedet for en mengde"
        checked={value.on} onChange={on => onChange({ on, count: value.count })}
      />
      {value.on && (
        <>
          <div style={choice.divider} />
          <div style={styles.row}>
            <span style={choice.label}>Antall lass</span>
            <div style={styles.stepper}>
              <button type="button" aria-label="Færre lass" style={styles.btn} disabled={value.count <= 1} onClick={() => step(-1)}>−</button>
              <span style={styles.count}>{value.count}</span>
              <button type="button" aria-label="Flere lass" style={styles.btn} disabled={value.count >= max} onClick={() => step(1)}>+</button>
            </div>
          </div>
          {total != null && <div style={choice.hint}>{value.count} lass × {formatNo(payloadTons)} t = {formatNo(total)} t totalt</div>}
        </>
      )}
    </div>
  );
}

const styles = {
  row:     { display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
  stepper: { display: 'flex', alignItems: 'center', gap: 12 },
  btn:     { width: 40, height: 40, borderRadius: 99, border: `1px solid ${COLORS.border}`, background: COLORS.white, color: COLORS.textDark, fontSize: 20, fontWeight: 700, cursor: 'pointer' },
  count:   { minWidth: 24, textAlign: 'center', fontSize: 20, fontWeight: 700, color: COLORS.textDark },
};
